export default __webpack_public_path__ + "static/media/gallery_08.18c79227.jpg";